// extracted by mini-css-extract-plugin
export default {"setting":"settings_setting__VzDUI","toggle_buttons":"settings_toggle_buttons__blQDK","show_screen":"settings_show_screen__udeJT"};